import { render, staticRenderFns } from "./tab-twoClient.vue?vue&type=template&id=70765c4d&"
import script from "./tab-twoClient.vue?vue&type=script&lang=ts&"
export * from "./tab-twoClient.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports